<template>
  <div class="page">
    <div class="header">
      <div class="tips">{{ result.totalScore }}分
        <div class="">
          <span class="text fs13"> <span class="grey fs15">{{ desc }}</span> 错题数目： {{ result.errorCount }}</span>
        </div>
      </div>
    </div>
    <div class="body">
      <div class="item" v-for="(item, index) in result.subject_list" :key="index">
        <div class="fs12 fwb">第{{ index + 1 }}题<span class="ml10">{{ item.subject_type }}</span></div>
        <div class="question">
          {{ item.subject }}
        </div>
        <div class="answer">
          <div class="m10 fs13" v-for="(item, index) in item.choose_list" :key="index">{{ item }}</div>
          <div class="an">正确答案：{{ item.answer }}</div>
          <div class="an" :class="{ red: item.answer != item.an?.split('').join(',') }">您的答案：{{
            item.an?.split('').join(',') }}</div>
          <div class="an"><span style="font-weight: bold; margin-right: 5px">题目解析:  </span> {{ item.analysis }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { examDetail } from '@/api/shopapi'
export default {
  data() {
    return {
      result: {},
      desc: ''
    }
  },
  async created() {
    if (this.$route.params.id) {
      const { data } = await examDetail({id: this.$route.params.id})
      var result = this.answerFormat(data)
    } else {
      var result = JSON.parse(localStorage.getItem('examResult'))
    }
    if (result.totalScore < result.pass_score) {
        this.desc = '请再接再厉！'
    } else if (result.totalScore >= result.pass_score && result.errorCount != 0) {
      this.desc = '恭喜您通过考试！'
    } else {
      this.desc = '恭喜满分通过！'
    }
    this.result = result
  },
  methods: {
    answerFormat (result) {
      result.totalScore = result.user_score
      result.errorCount = result.answer_list.filter(r => r.score === 0).length
      result.subject_list.forEach(r => {
        const res = result.answer_list.find(b => b.subject_id === r.subject_id) 
        r.an = res.answer ? res.answer.split(',').join('') : ''
        // r.analysis = '这是一个题目解析.这是一个题目解析.这是一个题目解析.这是一个题目解析.这是一个题目解析.这是一个题目解析.这是一个题目解析.这是一个题目解析.这是一个题目解析.'
      })
      return result
    }
  }
}
</script>
<style scoped>
.page {
  background-color: #f3f2f2;
  min-height: 100vh;
  font-size: 0.35rem;
}

.header {
  padding: 0 40px;
  background-color: #fff;
}

.tips {
  color: #E7153A;
  font-weight: bold;
  font-size: 17px;
  padding: 20px 0;
}

.subType {
  text-align: center;
  padding: 5px;

}

.text {
  position: relative;
  box-sizing: border-box;
  padding: 10px 0;
  color: #333;

}

.body {
  padding: 20px 15px;
}

.item {
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
  padding: 15px 20px;
  border-radius: 5px;
  margin-bottom: 15px;
}

.ml10 {
  margin-left: 5px;
}

.question {
  padding: 15px 0;
}

.footer {
  margin-top: 20px;
  display: flex;
  justify-content: space-around;
}

.m10 {
  margin: 8px 0;
  align-items: flex-start !important;
}

.an {
  line-height: 2;
  border-top: 1px solid #f3f2f2;
  border-bottom: 1px solid #f3f2f2;
}

.grey {
  color: #999;
}

.red {
  color: red;
}
</style>
